import { create } from "zustand";
import type { TaskSchedule } from "../types";

interface TaskScheduleState {
	modalOpen: boolean;
	editingItem: TaskSchedule | null;
}

interface TaskScheduleActions {
	onOpen: (item?: TaskSchedule) => void;
	closeModal: () => void;
}

type TaskScheduleStore = TaskScheduleState & TaskScheduleActions;

export const useTaskScheduleStore = create<TaskScheduleStore>((set) => ({
	modalOpen: false,
	editingItem: null,

	onOpen: (item) => set({ modalOpen: true, editingItem: item ?? null }),
	closeModal: () => set({ modalOpen: false, editingItem: null }),
}));
